import { render, staticRenderFns } from "./SearchSetup.vue?vue&type=template&id=d856072e&scoped=true&"
import script from "./SearchSetup.vue?vue&type=script&lang=js&"
export * from "./SearchSetup.vue?vue&type=script&lang=js&"
import style0 from "./SearchSetup.vue?vue&type=style&index=0&id=d856072e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d856072e",
  null
  
)

export default component.exports